<template>
  <div class="app-container">
    <div>
      <!-- 卡片1 开始 -->
      <el-card class="card">
        <el-row :gutter="24">
          <el-col :span="3">
            <el-date-picker
              v-model="date"
              type="date"
              placeholder="分析日期"
              format="yyyyMMdd"
              value-format="yyyyMMdd"
              clearable
            >
            </el-date-picker>
          </el-col>
          <el-col :span="12">
            <el-button type="primary" @click="Search()" icon="el-icon-search">查询</el-button>
            <el-button @click="toResetCondition()" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <!-- 卡片1 结束 -->

      <!-- 卡片2 开始 -->
      <el-card class="card">
        <el-table
          v-loading="fullscreenLoading"
          element-loading-text="努力加载中..."
          :data="tableData"
          style="width: 100%;margin-top: 10px;min-height:650px"
          height="calc(100vh - 480px)"
          stripe
          show-header
          border
          highlight-current-row
          :header-cell-style="{ background: '#f8f8f9', color: '#000000' }"
          :cell-style="{ align: 'center' }"
        >
          <el-table-column align="center" prop="filePath" label="文件名称"> </el-table-column>
          <el-table-column align="center" prop="gmtCreate" label="生成时间"> </el-table-column>
          <el-table-column align="center" prop="transactionDate" label="操作" width="130">
            <template slot-scope="scope">
              <el-link type="primary" :href="scope.row.fileUrl">
                下载
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!-- 卡片2 结束 -->
    </div>
  </div>
</template>

<script>
import * as noRouteAnalysisApi from '@/api/norouteanalysis'
import { tokenVerify } from '@/util/common'

export default {
  name: 'NoRouteList',
  data() {
    return {
      pagesize: 10,
      currpage: 1,
      tableData: [],

      // 查询条件账期
      date: '',
      // 加载样式
      fullscreenLoading: false,
    }
  },
  created() {},
  methods: {
    // 查询销售数据
    async Search() {
      if (this.date == '' || this.date == null) {
        this.$message.error('日期必选，请检查!')
        return
      }

      this.fullscreenLoading = true
      const response = await noRouteAnalysisApi.list({
        date: this.date,
      })

      tokenVerify(this, response)

      this.tableData = response.data.data
      this.fullscreenLoading = false
    },

    //重置所有查询条件
    toResetCondition() {
      this.date = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  width: 99%;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(11, 37, 64, 0.1);
  border-radius: 4px;
  margin: 10px 10px 12px 10px;
}
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

/**起飞到达日期输入框宽度 */
.el-date-editor.el-input {
  width: 100%;
}

::v-deep {
  .el-form-item {
    margin-bottom: 4px;
  }
}
</style>
